import React from "react";
import {
  Col,
  Row,
  Timeline,
  Button,
  Spin,
  Select,
  Radio,
  Tooltip,
  notification,
} from "antd";
import { useEffect, useRef, useState } from "react";
import {
  Check,
  CircleEllipsis,
  HelpCircle,
  Loader2,
  XCircle,
} from "lucide-react";
import { LoadingOutlined } from "@ant-design/icons";
import WebUtils from "../utils/WebUtils";
import { getBotConfigurationApi, previewLogApi } from "../../api";
import Utils from "../utils/Utils";
import Icon from "../../assets/Icon";
import TestModal from "./TestModal";
import { useLocation } from "react-router-dom";
import PreviewRejoinModal from "./PreviewRejoinModal";
import TutorialModal from "./TutorialModal";
import MonitorModal from "../monitorTools/MonitorModal";
import StatusCheckModal from "../monitorTools/StatusCheckModal";
import MonitorDownloadHelp from "../modals/MonitorDownloadHelp";

let osVer = Utils.getOSVersion();
let os = Utils.detectOS();

function PreviewChecklist({
  socket,
  ip,
  network,
  setNetwork,
  setDeepgramStatus,
  callFinalLogApi,
  setCallFinalLogApi,
  setLoading,
  setPreviewFlag,
  setAiTwoWayFlag,
  currentUserVideoRef,
  currentVideoStream,
  setCurrentVideoStream,
  interviewData,
  setConversationHistory,
  previewConfig,
  screenShareStream,
  setScreenShareStream,
  currentAudioStream,
  setCurrentAudioStream,
  setConcludeDemo,
  concludeDemo,
  previewFlag,
  setMonitorFlag,
  monitorFlag,
}) {
  const [videoStreamFlag, setVideoStreamFlag] = useState();
  const [audioStreamFlag, setAudioStreamFlag] = useState();
  const [networkErrMsg, setNetworkErrMsg] = useState("");

  const audioAllowStartedFlag = useRef(false);
  const videoAllowStartedFlag = useRef(false);
  const [videoDevices, setVideoDevices] = useState([]);
  const [selectedVideoDeviceId, setSelectedVideoDeviceId] = useState(null);

  const [audioDevices, setAudioDevices] = useState([]);
  const [selectedAudioDeviceId, setSelectedAudioDeviceId] = useState(null);

  const [logCode, setLogCode] = useState("Start interview success");
  const [logMessage, setLogMessage] = useState("Successfully passed");

  const [tutorialModalFlag, setTutorialModalFlag] = useState(false);
  const [suspiciousFlag, setSuspiciousFlag] = useState(false);

  let browserData = navigator;
  const [browser, setBrowser] = useState("");
  const [browserVer, setBrowserVer] = useState("");
  const [browserCopatibility, setBrowserCopatibility] = useState();
  const [testModal, setTestModal] = useState(false);
  const [scanFlag, setScanFlag] = useState(true);
  const [loadingHealth, setLoadingHealth] = useState(false);
  const [monitorStatusModalFlag, setMonitorStatusModalFlag] = useState(false);
  const [monitorStatusData, setMonitorStatusData] = useState(null);

  const [checkButtons, setCheckButtons] = useState({
    browserCheck: false,
    networkCheck: false,
    videoCheck: false,
    audioCheck: false,
    pingCheck: false,
    ssCheck: false,
    demo: false,
  });
  const [troubleshoot, setTroubleshoot] = useState({
    browserTroubleshoot: null,
    networkTroubleshoot: "",
    videoTroubleshoot: null,
    audioTroubleshoot: null,
    ssTroubleshoot: null,
    pingTroubleshoot: "",
  });
  const [errorText, setErrorText] = useState({
    videoError: "",
    audioError: "",
    ssError: "",
    browserError: "",
  });
  const [checkLoads, setCheckLoads] = useState({
    browserLoad: false,
    networkLoad: false,
    videoLoad: false,
    audioLoad: false,
    ssLoad: false,
    pingLoad: false,
  });

  const [previewRejoinModal, setPreviewRejoinModal] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const interviewId = queryParams.get("interviewId");
  const [downloadHelpModal, setDownloadHelpModal] = useState(null);

  const requestBody = {
    role: interviewData?.userRole,
    name: interviewData?.name,
    osType: os,
    osVersion: osVer,
    browserType: browser,
    browserVersion: browserVer,
    ipAddress: ip,
    systemSpecs: {
      cookieEnabled: browserData.cookieEnabled,
      downLink: browserData.connection?.downLink,
      rtt: browserData.connection?.rtt,
      effectiveType: browserData.connection?.effectiveType,
      language: browserData.language,
      hardwareConcurrency: browserData.hardwareConcurrency,
      deviceMemory: browserData.deviceMemory,
      pdfViewerEnabled: browserData.pdfViewerEnabled,
    },
    dateTimeInfo: new Date().toISOString().slice(0, -5),
    logCode: logCode,
    logMessage: logMessage,
  };
  const [speechEndDetector, setSpeechEndDetector] = useState("VAD");
  const [pauseValue, setPauseValue] = useState("Normal");

  const onSpeechEndRadioChange = (value) => {
    setSpeechEndDetector(value);
  };

  const onPauseRadioChange = (value) => {
    setPauseValue(value);
  };

  function browserCheck() {
    let userAgent = navigator.userAgent;

    // Detect Chrome
    if (/Edg/.test(userAgent)) {
      // browser = "Microsoft Edge";
      setBrowser("Microsoft Edge");
      setBrowserVer(userAgent.match(/Edg\/(\d+)/)[1]);
      setBrowserCopatibility(true);
      setCheckButtons({ ...checkButtons, browserCheck: true });
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      // browser = "Google Chrome";
      setBrowser("Google Chrome");
      setBrowserVer(userAgent.match(/Chrome\/(\d+)/)[1]);
      setBrowserCopatibility(true);
      setCheckButtons({ ...checkButtons, browserCheck: true });
    }

    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      // browser = "Mozilla Firefox";
      setBrowser("Mozilla Firefox");
      setBrowserVer(userAgent.match(/Firefox\/(\d+)/)[1]);
      // setBrowserCopatibility(true);
      setCheckButtons({ ...checkButtons, browserCheck: false });
      setErrorText({ ...errorText, browserError: "Browser incompatible" });
      setTroubleshoot({ ...troubleshoot, browserTroubleshoot: true });
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      setBrowser("Apple Safari");
      setBrowserVer(userAgent.match(/Version\/(\d+)/)[1]);
      // setBrowserCopatibility(true);
      setCheckButtons({ ...checkButtons, browserCheck: false });
      setErrorText({ ...errorText, browserError: "Browser incompatible" });
      setTroubleshoot({ ...troubleshoot, browserTroubleshoot: true });
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      // browser = "Internet Explorer";
      setBrowser("Internet Explorer");
      setBrowserVer(userAgent.match(/Trident\/\d+.*rv:(\d+)/)[1]);
      setCheckButtons({ ...checkButtons, browserCheck: false });
      setErrorText({ ...errorText, browserError: "Browser incompatible" });
      setTroubleshoot({ ...troubleshoot, browserTroubleshoot: true });
    }
    if (browser == "Apple Safari") {
      setBrowser("Apple Safari");
      setBrowserVer(userAgent.match(/Version\/(\d+)/)[1]);
      setCheckButtons({ ...checkButtons, browserCheck: false });
      setErrorText({ ...errorText, browserError: "Browser incompatible" });
      setTroubleshoot({ ...troubleshoot, browserTroubleshoot: true });
      requestBody.logCode = "failed";
      requestBody.logMessage = "Apple safari browser";
      loggedApi();
    }
  }

  const establishDeepgramSockets = () => {
    socket.on("TrancriptionSocketStatus", (status) => {
      setDeepgramStatus((prev) => ({
        ...prev,
        TrancriptionSocketStatus: status.connected,
      }));
    });
    socket.on("SpeechSynthesisSocketStatus", (status) => {
      setDeepgramStatus((prev) => ({
        ...prev,
        SpeechSynthesisSocketStatus: status.connected,
      }));
    });
  };

  const getConversationData = () => {
    setLoading(true);
    const url = `${getBotConfigurationApi}?interviewId=${interviewData?.interviewId}&interviewType=${interviewData?.interviewType}`;

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          if (result.data.data.interviewState === "YET_TO_START") {
            setConversationHistory({
              ...result.data.data,
              speechEndDetector,
              speechEndTimer: pauseValue,
            });
            socket.emit("initializeInterview", {
              ...result.data.data,
              speechEndDetector,
              speechEndTimer: pauseValue,
            });
            loggedApi(true);
          } else if (result.data.data.interviewState === "COMPLETED") {
            window.location.href = `/interview-completed?interviewId=${interviewData?.interviewId}`;
          }
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    browserCheck();
  }, []);

  //call apis after join interview check
  useEffect(() => {
    if (network && callFinalLogApi) {
      establishDeepgramSockets();
      getConversationData();
      // setCallFinalLogApi(false);
    }
  }, [callFinalLogApi, network]);

  //check if the preview checks are completed for join interview
  useEffect(() => {
    if (checkButtons && previewConfig) {
      (checkButtons.videoCheck || !previewConfig?.videoRecordingRequired) &&
      (checkButtons.ssCheck || !previewConfig?.screenRecordingRequired)
        ? checkButtons.audioCheck
          ? setPreviewFlag(true)
          : setPreviewFlag(false)
        : setPreviewFlag(false);
    }
  }, [checkButtons, previewConfig]);

  //check socket connection
  useEffect(() => {
    if (checkButtons.browserCheck && interviewData) {
      setCheckLoads((prev) => ({ ...prev, networkLoad: true }));
      if (socket?.connected) {
        checkSocketNetwork();
      } else {
        socket?.on("RoomFull", () => {
          setCheckLoads((prev) => ({ ...prev, networkLoad: false }));
          setCheckButtons((prev) => ({ ...prev, networkCheck: false }));
          setNetwork(false);
          setNetworkErrMsg("This room already has a candidate.");
        });
        socket?.on("connect", checkSocketNetwork);
        socket?.on("connect_error", handleSocketConnectError);
      }
    }

    return () => {
      socket?.off("connect", checkSocketNetwork);
      socket?.off("connect_error", handleSocketConnectError);
    };
  }, [checkButtons.browserCheck, socket, interviewData]);

  const checkSocketNetwork = () => {
    if (socket?.connected) {
      setCheckButtons((prev) => ({ ...prev, networkCheck: true }));
      setNetwork(true);
      setNetworkErrMsg("");
      socket.emit("join-room", interviewData);
      socket.on("user-connected", (interviewData) => {
        console.log("User joined room: ", interviewData);
      });
      socket.on("RoomFull", () => {
        setCheckLoads((prev) => ({ ...prev, networkLoad: false }));
        setCheckButtons((prev) => ({ ...prev, networkCheck: false }));
        setNetwork(false);
        setNetworkErrMsg("This room already has a candidate.");
      });
    } else {
      setNetwork(false);
    }
    setCheckLoads((prev) => ({ ...prev, networkLoad: false }));
  };

  const handleSocketConnectError = (error) => {
    setCheckLoads((prev) => ({ ...prev, networkLoad: false }));
    setNetwork(false);
    if (error.message.includes("Invalid")) {
      setNetworkErrMsg(error.message);
    } else {
      setNetworkErrMsg("Failed to connect to the server.");
    }
    // requestBody.logCode = "Failed";
    // requestBody.logMessage = "Failed to connect to socket server.";
    // loggedApi();
  };

  useEffect(() => {
    if (screenShareStream) {
      screenShareStream.getVideoTracks()[0].onended = () => {
        const tracks = screenShareStream.getTracks();
        tracks.forEach((track) => track.stop());
        startScreenShare();
      };
    }
  }, [screenShareStream]);

  const startScreenShare = () => {
    navigator.mediaDevices
      .getDisplayMedia({
        video: {
          width: { max: 1280 },
          height: { max: 720 },
          frameRate: { ideal: 15, max: 20 },
        },
        audio: false,
      })
      .then((stream) => {
        if (
          stream.getVideoTracks()[0].getSettings().displaySurface != "monitor"
        ) {
          if (
            typeof stream.getVideoTracks()[0].getSettings().displaySurface ===
            "undefined"
          ) {
            setScreenShareStream(stream);
          } else {
            stream.getTracks().forEach((track) => {
              track.stop();
            });
            setErrorText({
              ...errorText,
              ssError: "Please share your entire screen to proceed further",
            });
            setTroubleshoot({ ...troubleshoot, ssTroubleshoot: true });
          }
        } else {
          setErrorText({ ...errorText, ssError: "" });
          setCheckButtons({ ...checkButtons, ssCheck: true });
          setScreenShareStream(stream);
        }
      })
      .catch((e) => {
        requestBody.logCode = "failed";
        requestBody.logMessage = "Screen Share is not accessible ";
        loggedApi();
        // setErrorMessage("Could not access screen");
        setErrorText({
          ...errorText,
          ssError: "Screen Share is not accessible",
        });
        startScreenShare();
      });
  };

  const handleVideoChange = (id) => {
    setSelectedVideoDeviceId(id);
    checkVideoStart(id);
  };
  const handleAudioChange = (id) => {
    setSelectedAudioDeviceId(id);
    checkAudioStart(id);
  };

  const enumerateVideoDevices = () => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const videoInputDevices = devices.filter(
          (device) => device.kind === "videoinput",
        );
        setVideoDevices(videoInputDevices);
        if (videoInputDevices.length > 0) {
          setSelectedVideoDeviceId(videoInputDevices[0].deviceId);
          checkVideoStart(videoInputDevices[0].deviceId);
        }
      })
      .catch((err) => {
        console.error("Error enumerating devices.", err);
      });
  };

  const enumerateAudioDevices = () => {
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const audioInputDevices = devices
          .filter((device) => device.kind === "audioinput")
          .filter((device) => device.deviceId !== "communications");

        if (audioInputDevices.length > 0) {
          setSelectedAudioDeviceId(audioInputDevices[0].deviceId);
          checkAudioStart(audioInputDevices[0].deviceId);
        }
        setAudioDevices(audioInputDevices);
      })
      .catch((err) => {
        console.error("Error enumerating devices.", err);
      });
  };

  const allowVideo = () => {
    setCheckLoads({ ...checkLoads, videoLoad: true });
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        enumerateVideoDevices();
        videoAllowStartedFlag.current = true;
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((error) => {
        if (error.message.includes("Permission denied")) {
          setErrorText({
            ...errorText,
            videoError: "Permission denied by system",
          });
          setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
          setCheckLoads({ ...checkLoads, videoLoad: false });
          requestBody.logCode = "failed";
          requestBody.logMessage = "Web cam not found in device";
          loggedApi();
          setVideoStreamFlag(false);
          return;
        } else {
          setErrorText({
            ...errorText,
            videoError: "Webcam not found or not working",
          });
          setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
          setCheckLoads({ ...checkLoads, videoLoad: false });
          requestBody.logCode = "failed";
          requestBody.logMessage = "Web cam not found or camera is not working";
          loggedApi();
          setVideoStreamFlag(false);
          return;
        }
      });
  };
  const allowAudio = () => {
    setCheckLoads({ ...checkLoads, audioLoad: true });
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        enumerateAudioDevices();
        audioAllowStartedFlag.current = true;
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((error) => {
        setAudioStreamFlag(false);
        setCheckLoads({ ...checkLoads, audioLoad: false });
        console.error("Microphone error:", error);
        setErrorText({
          ...errorText,
          audioError: "Microphone is not accessible",
        });
        setTroubleshoot({ ...troubleshoot, audioTroubleshoot: true });
        requestBody.ipAddress = ip;
        requestBody.logCode = "failed";
        requestBody.logMessage = "failed microphone access ";
        loggedApi();
      });
  };

  const checkVideoStart = (videoId) => {
    if (currentVideoStream) {
      currentVideoStream.getTracks().forEach((track) => track.stop());
    }
    const constraints = {
      video: {
        width: { min: 256, ideal: 426, max: 677 },
        height: { min: 144, ideal: 240, max: 380 },
        frameRate: { ideal: 18, max: 18 },
        deviceId: videoId ? { exact: videoId } : undefined,
      },
    };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        setCurrentVideoStream(stream);

        currentUserVideoRef.current.srcObject = stream;
        currentUserVideoRef.current.style.transform = "scaleX(-1)";
        setVideoStreamFlag(true);
        setErrorText({ ...errorText, videoError: "" });
        setCheckLoads({ ...checkLoads, videoLoad: false });
        setCheckButtons({ ...checkButtons, videoCheck: true });
        setTroubleshoot({ ...troubleshoot, videoTroubleshoot: false });
      })
      .catch((error) => {
        if (error.message.includes("Permission denied")) {
          setErrorText({
            ...errorText,
            videoError: "Permission denied by system",
          });
          setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
          setCheckLoads({ ...checkLoads, videoLoad: false });
          requestBody.logCode = "failed";
          requestBody.logMessage = "Web cam not found in device ";
          loggedApi();
          setVideoStreamFlag(false);
          return;
        } else if (error.message.includes("Could not start video source")) {
          setErrorText({
            ...errorText,
            videoError: "Webcam not found or not working",
          });
          setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
          setCheckLoads({ ...checkLoads, videoLoad: false });
          requestBody.logCode = "failed";
          requestBody.logMessage = "Web cam not found or camera is not working";
          loggedApi();
          setVideoStreamFlag(false);
          return;
        } else if (error.message.includes("Device in use")) {
          setErrorText({
            ...errorText,
            videoError: "Device in use",
          });
          setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
          setCheckLoads({ ...checkLoads, videoLoad: false });
          requestBody.logCode = "failed";
          requestBody.logMessage = "Device in use ";
          loggedApi();
          setVideoStreamFlag(false);
          return;
        }
        console.error("Webcam error:", error);
        setErrorText({ ...errorText, videoError: "Camera is not accessible" });
        setTroubleshoot({ ...troubleshoot, videoTroubleshoot: true });
        setCheckLoads({ ...checkLoads, videoLoad: false });
        requestBody.ipAddress = ip;
        requestBody.logCode = "failed";
        requestBody.logMessage = "Camera is not accessible ";
        loggedApi();
      });
  };

  const checkAudioStart = (audioId) => {
    if (currentAudioStream) {
      currentAudioStream.getTracks().forEach((track) => track.stop());
    }
    const constraints = {
      audio: {
        deviceId: audioId ? { exact: audioId } : undefined,
        noiseSuppression: true,
        echoCancellation: true,
      },
    };
    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => {
        setCurrentAudioStream(stream);

        setAudioStreamFlag(true);
        setErrorText({
          ...errorText,
          audioError: "",
        });
        setCheckButtons({ ...checkButtons, audioCheck: true });
        setCheckLoads({ ...checkLoads, audioLoad: false });
        setTroubleshoot({ ...troubleshoot, audioTroubleshoot: false });
      })
      .catch((error) => {
        setAudioStreamFlag(false);
        setCheckLoads({ ...checkLoads, audioLoad: false });
        console.error("Microphone error:", error);
        setErrorText({
          ...errorText,
          audioError: "Microphone is not accessible",
        });
        setTroubleshoot({ ...troubleshoot, audioTroubleshoot: true });
        requestBody.ipAddress = ip;
        requestBody.logCode = "failed";
        requestBody.logMessage = "failed microphone access ";
        loggedApi();
      });
  };

  const loggedApi = (endFlag = false) => {
    setLoading(true);
    let url = previewLogApi + `?interviewId=${interviewData?.interviewId}`;

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          if (endFlag && interviewData?.interviewType === "AI_TWO_WAY") {
            setAiTwoWayFlag(true);
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleDeviceDisconnect = () => {
    if (audioAllowStartedFlag.current || videoAllowStartedFlag.current) {
      setPreviewRejoinModal(true);
    }
  };

  useEffect(() => {
    if (!callFinalLogApi) {
      navigator.mediaDevices.addEventListener(
        "devicechange",
        handleDeviceDisconnect,
      );
    }

    return () => {
      navigator.mediaDevices.removeEventListener(
        "devicechange",
        handleDeviceDisconnect,
      );
    };
  }, [callFinalLogApi]);

  const downloadWindowsMonitorFile = (windows = true) => {
    let url;
    if (windows) {
      url =
        "https://hireplusplus-public-in.s3.ap-south-1.amazonaws.com/monitoringTool/windows/HPPMonitoringTool.exe";
    } else {
      url =
        "https://hireplusplus-public-in.s3.ap-south-1.amazonaws.com/monitoringTool/mac/HPPMonitoringTool.dmg";
    }

    const link = document.createElement("a");
    link.href = url;
    // link.download = "windows-monitor-tool.exe"; // file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    // setScanFlag(true);
  };

  const checkHealth = async () => {
    try {
      setLoadingHealth(true);
      const response = await fetch("http://localhost:9191/health", {
        method: "GET",
      });

      const data = await response.json(); // or response.json() if API returns JSON
      console.log("Health API response:", data);
      if (data?.data?.status === "ok") {
        setMonitorFlag(true);
        statusCheck();
      } else {
        setMonitorFlag(false);
      }
    } catch (error) {
      setMonitorFlag(false);
      console.error("Error calling health API:", error);
    } finally {
      setLoadingHealth(false);
    }
  };

  const statusCheck = async () => {
    try {
      // setLoading(true);

      const response = await fetch("http://localhost:9191/api/v1/status", {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer exdsfrty7365378TerdstAIOP!@123",
        },
      });

      const data = await response.json();

      // console.log("Status:", data);
      if (data?.resultStatusInfo?.resultCode === "SUCCESS") {
        setMonitorStatusModalFlag(true);
        setMonitorStatusData(data?.data);
        if (data?.data?.suspicious_count > 0) {
          setSuspiciousFlag(true);
        } else {
          setSuspiciousFlag(false);
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        !loadingHealth &&
        network &&
        concludeDemo === true &&
        previewConfig?.monitoringToolEnabled
      ) {
        checkHealth();
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [loadingHealth, concludeDemo]);

  useEffect(() => {
    if (concludeDemo && network && previewConfig?.monitoringToolEnabled) {
      checkHealth();
    }
  }, [concludeDemo]);
  return (
    <>
      {downloadHelpModal && (
        <MonitorDownloadHelp
          modalType={downloadHelpModal}
          onClose={() => setDownloadHelpModal(null)}
        />
      )}
      {previewRejoinModal && (
        <PreviewRejoinModal
          previewRejoinModal={previewRejoinModal}
          interviewId={interviewId}
        />
      )}
      {testModal && (
        <TestModal testModal={testModal} setTestModal={setTestModal} />
      )}
      {tutorialModalFlag && (
        <TutorialModal
          tutorialModalFlag={tutorialModalFlag}
          setTutorialModalFlag={setTutorialModalFlag}
          setConcludeDemo={setConcludeDemo}
        />
      )}
      {monitorStatusModalFlag && (
        <StatusCheckModal
          monitorStatusModalFlag={monitorStatusModalFlag}
          setMonitorStatusModalFlag={setMonitorStatusModalFlag}
          monitorStatusData={monitorStatusData}
          setCallFinalLogApi={setCallFinalLogApi}
          previewFlag={previewFlag}
          network={network}
          concludeDemo={concludeDemo}
          monitorFlag={monitorFlag}
          currentVideoStream={currentVideoStream}
          suspiciousFlag={suspiciousFlag}
          setMonitorStatusData={setMonitorStatusData}
          setSuspiciousFlag={setSuspiciousFlag}
        />
      )}
      {/* {monitorfailedModalFlag && (
        <MonitorModal
          monitorfailedModalFlag={monitorfailedModalFlag}
          setMonitorfailedModalFlag={setMonitorfailedModalFlag}
        />
      )} */}
      <div>
        {" "}
        <Row className="">
          <Col md={24} className="" style={{ width: "100%" }}>
            <div className="" style={{ width: "100%" }}>
              <Row className="" style={{ width: "100%" }}>
                <Col md={16} className="" style={{ width: "100%" }}>
                  <div
                    className="mb-[.8rem]"
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "500",
                      marginLeft: "20px",
                    }}
                  >
                    Checklist
                  </div>
                  <Timeline
                    style={{ paddingLeft: "40px" }}
                    items={[
                      {
                        dot: browserCopatibility ? (
                          <Check color="#0af906" />
                        ) : (
                          <XCircle color="#f90606" />
                        ),
                        color: browserCopatibility ? "green" : "red",
                        children: (
                          <>
                            <div
                              className=""
                              style={{ fontWeight: 400, fontSize: "0.94rem" }}
                            >
                              Browser Compatibility{" "}
                            </div>
                            <div
                              className="text-gray-500 mb-[-.5rem]"
                              style={{ fontWeight: 500 }}
                            >
                              {browser} {browserVer}
                            </div>
                          </>
                        ),
                      },

                      {
                        dot:
                          network === undefined ? (
                            <CircleEllipsis color="#326efb" />
                          ) : network === true ? (
                            <Check color="#0af906" />
                          ) : (
                            <XCircle color="#f90606" />
                          ),

                        children: (
                          <>
                            <div className="flex mt-2 gap-2">
                              <p
                                className=""
                                style={{
                                  fontWeight: 400,
                                  fontSize: "0.94rem",
                                  display: "inline-block",
                                }}
                              >
                                Network Compatibility{" "}
                              </p>
                              <Spin
                                className="flex"
                                spinning={
                                  checkLoads.networkLoad &&
                                  checkButtons.browserCheck
                                }
                                indicator={
                                  <LoadingOutlined
                                    style={{
                                      fontSize: 18,
                                    }}
                                    spin
                                  />
                                }
                              ></Spin>
                            </div>
                            {networkErrMsg && (
                              <div className="text-[#f76161] text-[.87rem] font-semibold mb-[-.55rem] leading-[1.175rem]">
                                {networkErrMsg}
                              </div>
                            )}
                          </>
                        ),
                      },
                      {
                        dot:
                          audioStreamFlag == undefined ? (
                            <CircleEllipsis color="#326efb" />
                          ) : audioStreamFlag === true ? (
                            <Check color="#0af906" />
                          ) : (
                            <XCircle color="#f90606" />
                          ),
                        children: (
                          <>
                            <div className="flex mt-2 mb-2 gap-2">
                              <p
                                className=""
                                style={{
                                  fontWeight: 400,
                                  fontSize: "0.94rem",
                                  display: "inline-block",
                                }}
                              >
                                {" "}
                                Accessing Audio{" "}
                              </p>
                              <Spin
                                className="flex"
                                spinning={
                                  checkLoads.audioLoad &&
                                  checkButtons.networkCheck
                                }
                                indicator={
                                  <LoadingOutlined
                                    style={{
                                      fontSize: 18,
                                    }}
                                    spin
                                  />
                                }
                              >
                                {network &&
                                  checkButtons.networkCheck === true &&
                                  checkButtons.audioCheck === false && (
                                    <Button onClick={allowAudio} className="">
                                      Allow
                                    </Button>
                                  )}
                              </Spin>
                              {/* <button
                                className="btn-blue px-5 py-1"
                                onClick={() => setTestModal(true)}
                              >
                                Test
                              </button> */}
                            </div>
                            {audioDevices.length > 0 && (
                              <Select
                                className="mt-[-0.3rem]"
                                style={{ width: "100%" }}
                                onChange={handleAudioChange}
                                placeholder="Select an audio device"
                                value={selectedAudioDeviceId}
                                dropdownStyle={{ width: "300px" }}
                              >
                                {audioDevices.map((device) => (
                                  <Select.Option
                                    key={device.deviceId}
                                    value={device.deviceId}
                                  >
                                    {device.label ||
                                      `Microphone ${device.deviceId}`}
                                  </Select.Option>
                                ))}
                              </Select>
                            )}
                          </>
                        ),
                      },
                      ...(previewConfig?.videoRecordingRequired
                        ? [
                            {
                              dot:
                                videoStreamFlag == undefined ? (
                                  <CircleEllipsis color="#326efb" />
                                ) : videoStreamFlag === true ? (
                                  <Check color="#0af906" />
                                ) : (
                                  <XCircle color="#f90606" />
                                ),
                              children: (
                                <>
                                  <div className="flex mb-2 gap-2">
                                    <div
                                      className=" "
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "0.94rem",
                                        display: "inline-block",
                                      }}
                                    >
                                      Accessing Video{" "}
                                    </div>
                                    <Spin
                                      className="flex"
                                      spinning={checkLoads.videoLoad}
                                      indicator={
                                        <LoadingOutlined
                                          style={{
                                            fontSize: 18,
                                          }}
                                          spin
                                        />
                                      }
                                    >
                                      {network &&
                                        checkButtons.audioCheck &&
                                        checkButtons.videoCheck === false && (
                                          <Button
                                            onClick={allowVideo}
                                            className="ml-1"
                                          >
                                            Allow
                                          </Button>
                                        )}
                                    </Spin>
                                  </div>
                                  {videoDevices.length > 0 && (
                                    <div className="mb-1 mt-[-0.3rem]">
                                      <Select
                                        style={{ width: "100%" }}
                                        onChange={handleVideoChange}
                                        placeholder="Select a video device"
                                        value={selectedVideoDeviceId}
                                        dropdownStyle={{ width: "280px" }}
                                      >
                                        {videoDevices.map((device) => (
                                          <Select.Option
                                            key={device.deviceId}
                                            value={device.deviceId}
                                          >
                                            {device.label ||
                                              `Camera ${device.deviceId}`}
                                          </Select.Option>
                                        ))}
                                      </Select>
                                    </div>
                                  )}
                                </>
                              ),
                            },
                          ]
                        : []),
                      ...(previewConfig?.screenRecordingRequired
                        ? [
                            {
                              dot:
                                screenShareStream == undefined ? (
                                  <CircleEllipsis color="#326efb" />
                                ) : screenShareStream ? (
                                  <Check color="#0af906" />
                                ) : (
                                  <XCircle color="#f90606" />
                                ),
                              children: (
                                <div className="flex gap-2">
                                  <div
                                    className=""
                                    style={{
                                      fontWeight: 400,
                                      fontSize: "0.94rem",
                                      display: "inline-block",
                                    }}
                                  >
                                    Share Screen{" "}
                                    {(checkButtons.videoCheck === true ||
                                      (previewConfig?.videoRecordingRequired ===
                                        false &&
                                        checkButtons.audioCheck === true)) &&
                                      checkButtons.ssCheck === false && (
                                        <p
                                          className="mb-[-1rem] leading-[1.1rem]"
                                          style={{
                                            fontWeight: 500,
                                            color: "#cf1322",
                                            fontSize: ".88rem",
                                          }}
                                        >
                                          Select entire screen
                                        </p>
                                      )}
                                  </div>
                                  <Spin
                                    className="flex"
                                    spinning={checkLoads.ssLoad}
                                    indicator={
                                      <LoadingOutlined
                                        style={{
                                          fontSize: 18,
                                        }}
                                        spin
                                      />
                                    }
                                  >
                                    {(checkButtons.videoCheck === true ||
                                      (previewConfig?.videoRecordingRequired ===
                                        false &&
                                        checkButtons.audioCheck === true)) &&
                                      checkButtons.ssCheck === false &&
                                      network && (
                                        <Button
                                          onClick={startScreenShare}
                                          className=""
                                        >
                                          Share
                                        </Button>
                                      )}
                                  </Spin>
                                </div>
                              ),
                            },
                          ]
                        : []),

                      {
                        dot: !concludeDemo ? (
                          <CircleEllipsis color="#326efb" />
                        ) : (
                          <Check color="#0af906" />
                        ),

                        children: (
                          <>
                            <div className="flex mt-2 mb-2 gap-2">
                              <p
                                className="flex gap-1"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "0.94rem",
                                  // display: "inline-block",
                                }}
                              >
                                {" "}
                                <span>Interactive Demo </span>
                                <Tooltip
                                  color={"#101828"}
                                  overlayInnerStyle={{
                                    color: "white",
                                    padding: "12px 15px",
                                    width: "280px",
                                  }}
                                  placement="right"
                                  title={
                                    <div className="text-[0.86rem]">
                                      Please complete the Interview Guide before
                                      proceeding with your interview.
                                    </div>
                                  }
                                >
                                  <div className=" hover:cursor-pointer">
                                    <Icon
                                      type="help-icon"
                                      color="#475467"
                                      strokeWidth="1.5"
                                      width="16px"
                                    />
                                  </div>
                                </Tooltip>{" "}
                              </p>

                              {network &&
                                (checkButtons.ssCheck === true ||
                                  previewConfig?.screenRecordingRequired ===
                                    false) &&
                                concludeDemo === false && (
                                  <Button
                                    onClick={() => setTutorialModalFlag(true)}
                                    className=""
                                  >
                                    Start demo
                                  </Button>
                                )}

                              {/* <button
                                className="btn-blue px-5 py-1"
                                onClick={() => setTestModal(true)}
                              >
                                Test
                              </button> */}
                            </div>
                          </>
                        ),
                      },

                      ...(previewConfig?.monitoringToolEnabled
                        ? [
                            {
                              dot: !monitorFlag ? (
                                <CircleEllipsis color="#326efb" />
                              ) : (
                                <Check color="#0af906" />
                              ),

                              children: (
                                <>
                                  <div className="flex flex-col mt-2 mb-2 gap-2">
                                    <p
                                      className="flex gap-2 items-center"
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "0.94rem",
                                        // display: "inline-block",
                                      }}
                                    >
                                      <span className="flex items-center gap-2">
                                        <span className="flex items-center gap-1">
                                          Monitoring tool{" "}
                                          <Tooltip
                                            color={"#101828"}
                                            overlayInnerStyle={{
                                              color: "white",
                                              padding: "12px 15px",
                                              width: "280px",
                                            }}
                                            placement="right"
                                            title={
                                              <div className="text-[0.86rem]">
                                                Monitoring tool helps detect
                                                suspicious activity during the
                                                interview, such as unauthorized
                                                apps or external displays.
                                                Download and run the tool using
                                                the link below to continue.
                                              </div>
                                            }
                                          >
                                            <div className=" hover:cursor-pointer">
                                              <Icon
                                                type="help-icon"
                                                color="#475467"
                                                strokeWidth="1.5"
                                                width="16px"
                                              />
                                            </div>
                                          </Tooltip>
                                        </span>
                                        {concludeDemo &&
                                          (monitorFlag ? (
                                            <span className="ml-[.4rem] flex font-semibold gap-[.4rem] items-center text-[.85rem] px-2 py-[1px] border-[1px] border-green-500 text-green-500 bg-green-50 rounded-full ">
                                              <Loader2
                                                color="#53A0F8"
                                                strokeWidth={2.8}
                                                size={15}
                                                className="animate-spin"
                                              />

                                              <span className="text-green-500">
                                                Detected
                                              </span>
                                            </span>
                                          ) : (
                                            <span className="ml-[.4rem] flex font-semibold gap-[.4rem] items-center text-[.85rem] px-2 py-[1px] border-[1px] border-red-500 text-red-500 bg-red-50 rounded-full ">
                                              <Loader2
                                                color="#53A0F8"
                                                strokeWidth={2.8}
                                                size={15}
                                                className="animate-spin"
                                              />

                                              <span className="text-red-500">
                                                Not detected
                                              </span>
                                            </span>
                                          ))}
                                      </span>
                                    </p>

                                    {network && concludeDemo === true && (
                                      <div>
                                        <div className="flex gap-x-[.3rem] items-center text-[#206DC5] flex-wrap">
                                          Download and run for
                                          <span
                                            onClick={() =>
                                              downloadWindowsMonitorFile(true)
                                            }
                                            className="text-blue-500 cursor-pointer hover:text-blue-400 underline font-semibold"
                                          >
                                            {" "}
                                            Windows
                                          </span>{" "}
                                          <Tooltip
                                            title=<div className="text-center">
                                              Click to see how to download for
                                              Windows
                                            </div>
                                          >
                                            <HelpCircle
                                              size={19}
                                              onClick={() =>
                                                setDownloadHelpModal("Windows")
                                              }
                                              className="cursor-pointer ml-[.15rem]"
                                            />
                                          </Tooltip>
                                        </div>
                                        <div className="flex gap-x-[.3rem] items-center text-[#206DC5] flex-wrap">
                                          Download and run for
                                          <span
                                            onClick={() =>
                                              downloadWindowsMonitorFile(false)
                                            }
                                            className="text-blue-500 cursor-pointer hover:text-blue-400 underline font-semibold"
                                          >
                                            {" "}
                                            MacOS
                                          </span>{" "}
                                          <Tooltip
                                            title=<div className="text-center">
                                              Click to see how to download for
                                              Mac
                                            </div>
                                          >
                                            <HelpCircle
                                              size={19}
                                              onClick={() =>
                                                setDownloadHelpModal("Mac")
                                              }
                                              className="cursor-pointer ml-[.15rem]"
                                            />
                                          </Tooltip>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </>
                              ),
                            },
                          ]
                        : []),
                    ]}
                  />
                </Col>
                {/* <Col md={1} /> */}
              </Row>
            </div>
          </Col>
          <div className="flex gap-[.65rem] flex-col px-2 sm:ml-3 xl:ml-0 w-[405px]">
            <div className="flex flex-col xs:flex-row justify-between items-start xs:items-center gap-2">
              <div className="font-semibold text-[.93rem] text-[#475467]">
                I am in a:
              </div>
              <div className="flex gap-[.8rem]">
                <Select
                  onChange={onSpeechEndRadioChange}
                  value={speechEndDetector}
                  defaultValue="VAD"
                  className="w-[180px] text-[.9rem]"
                  options={[
                    { value: "VAD", label: "Quiet environment" },
                    { value: "VAD2", label: "Noisy environment" },
                  ]}
                />
                <Tooltip
                  color={"#101828"}
                  overlayInnerStyle={{
                    color: "white",
                    padding: "12px 15px",
                    width: "310px",
                  }}
                  placement="right"
                  title={
                    <div className="text-[0.86rem]">
                      <p>
                        <span className="font-semibold">
                          Eg. for Quiet environment -
                        </span>{" "}
                        A serene library with only the faint rustle of pages
                        turning.
                      </p>
                      <p className="mt-2">
                        <span className="font-semibold">
                          Eg. for Noisy environment -
                        </span>{" "}
                        A bustling coffee shop filled with conversations,
                        clattering dishes, and background music.
                      </p>
                    </div>
                  }
                >
                  <div className="flex gap-2 justify-center items-center hover:cursor-pointer">
                    <Icon type="help-icon" color="#475467" strokeWidth="1.5" />
                  </div>
                </Tooltip>
              </div>
            </div>
            <div className="flex flex-col xs:flex-row justify-between items-start xs:items-center gap-2">
              <div className="font-semibold text-[.93rem] text-[#475467]">
                During speech, I take:
              </div>
              <div className="flex gap-[.8rem]">
                <Select
                  onChange={onPauseRadioChange}
                  value={pauseValue}
                  defaultValue="Normal"
                  className="w-[180px] text-[.9rem]"
                  options={[
                    { value: "Normal", label: "Normal pauses" },
                    { value: "Short", label: "Short pauses" },
                    { value: "Long", label: "Long pauses" },
                  ]}
                />
                <Tooltip
                  color={"#101828"}
                  overlayInnerStyle={{
                    color: "white",
                    padding: "12px 15px",
                    width: "310px",
                  }}
                  placement="right"
                  title={
                    <div className="text-[0.86rem]">
                      <p>
                        <span className="font-semibold">Normal pause -</span> A
                        brief silence while someone takes a breath before
                        continuing a sentence.
                      </p>
                      <p className="mt-2">
                        <span className="font-semibold">Short pause -</span> A
                        quick momentary pause, like a comma in spoken
                        conversation.
                      </p>
                      <p className="mt-2">
                        <span className="font-semibold">Long pause -</span> An
                        extended silence, often felt after asking a
                        thought-provoking question or when someone is searching
                        for the right words.
                      </p>
                    </div>
                  }
                >
                  <div className="flex gap-2 justify-center items-center hover:cursor-pointer">
                    <Icon type="help-icon" color="#475467" strokeWidth="1.5" />
                  </div>
                </Tooltip>
              </div>
            </div>
          </div>
        </Row>
      </div>
    </>
  );
}

export default PreviewChecklist;
